import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "annex-alarm-status-helper" }
const _hoisted_2 = { class: "part1" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "part2" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "678",
    height: "130",
    viewBox: "0 0 678 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M86 35V34.5H85.5V35H86ZM96 35L91 32.1132V37.8868L96 35ZM86 35.5H91.5V34.5H86V35.5ZM86.5 65V35H85.5V65H86.5Z",
      fill: "currentColor"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M86 95H85.5V95.5H86V95ZM96 95L91 92.1132V97.8868L96 95ZM86 65.5H86.5V65H86V65.5ZM86 95.5H91.5V94.5H86V95.5ZM76 66H86V65H76V66ZM85.5 65.5V95H86.5V65.5H85.5Z",
      fill: "currentColor"
    })
  ])
], -1)
const _hoisted_4 = { class: "part3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "part4" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "678",
    height: "130",
    viewBox: "0 0 678 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M251 35L246 32.1132V37.8868L251 35ZM231 35.5H246.5V34.5H231V35.5Z",
      fill: "currentColor"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M251 95L246 92.1132V97.8868L251 95ZM231 95.5H246.5V94.5H231V95.5Z",
      fill: "currentColor"
    })
  ])
], -1)
const _hoisted_6 = { class: "part3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "part4" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "678",
    height: "130",
    viewBox: "0 0 678 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M251 35L246 32.1132V37.8868L251 35ZM231 35.5H246.5V34.5H231V35.5Z",
      fill: "currentColor"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M251 95L246 92.1132V97.8868L251 95ZM231 95.5H246.5V94.5H231V95.5Z",
      fill: "currentColor"
    })
  ])
], -1)
const _hoisted_8 = { class: "part3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "part5" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "678",
    height: "130",
    viewBox: "0 0 678 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M462 35H462.5V34.5H462V35ZM462 66H461.5V66.5H462V66ZM472 66L467 63.1132V68.8868L472 66ZM452 35.5H462V34.5H452V35.5ZM461.5 35V66H462.5V35H461.5ZM462 66.5H467.5V65.5H462V66.5Z",
      fill: "currentColor"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M452 95H462V66.5",
      stroke: "currentColor"
    })
  ])
], -1)
const _hoisted_10 = { class: "part1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NButton = _resolveComponent("NButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_NButton, { class: "btn1" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('annex_alarms.helper.new')), 1)
        ]),
        _: 1
      })
    ]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_NButton, { class: "btn2" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('annex_alarms.helper.auto_accepted')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_NButton, { class: "btn2" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('annex_alarms.helper.accepted_rejected')), 1)
        ]),
        _: 1
      })
    ]),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_NButton, { class: "btn3" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('annex_alarms.helper.in_work')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_NButton, { class: "btn4" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('annex_alarms.helper.in_work')), 1)
        ]),
        _: 1
      })
    ]),
    _hoisted_7,
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_NButton, { class: "btn2" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('annex_alarms.helper.comment')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_NButton, { class: "btn2" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('annex_alarms.helper.comment')), 1)
        ]),
        _: 1
      })
    ]),
    _hoisted_9,
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_NButton, { class: "btn4" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('annex_alarms.helper.completed')), 1)
        ]),
        _: 1
      })
    ])
  ]))
}